/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Public_ListingInputs */

const en_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Public Listing`)
};

const es_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver anuncio público`)
};

const fr_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'annonce publique`)
};

const de_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentliches Inserat ansehen`)
};

const ja_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中の出品を見る`)
};

const zh_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看公开商品页面`)
};

const ar_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الإعلان العام`)
};

const id_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Listing Publik`)
};

const it_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi Annuncio Pubblico`)
};

const ru_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть публичное объявление`)
};

const pt_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Anúncio Público`)
};

const ko_view_public_listing = /** @type {(inputs: View_Public_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개된 상품 페이지 보기`)
};

/**
* | output |
* | --- |
* | "View Public Listing" |
*
* @param {View_Public_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_public_listing = /** @type {((inputs?: View_Public_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Public_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_public_listing(inputs)
	if (locale === "es") return es_view_public_listing(inputs)
	if (locale === "fr") return fr_view_public_listing(inputs)
	if (locale === "de") return de_view_public_listing(inputs)
	if (locale === "ja") return ja_view_public_listing(inputs)
	if (locale === "zh") return zh_view_public_listing(inputs)
	if (locale === "ar") return ar_view_public_listing(inputs)
	if (locale === "id") return id_view_public_listing(inputs)
	if (locale === "it") return it_view_public_listing(inputs)
	if (locale === "ru") return ru_view_public_listing(inputs)
	if (locale === "pt") return pt_view_public_listing(inputs)
	return ko_view_public_listing(inputs)
});